module.exports = __webpack_public_path__ + "img/cards.5ae6df6.svg";